import { mapActions, mapState, mapGetters } from "vuex";
import checkPermission from "../../src/service/checkPermission.js";
export default {
  data() {
    return {
      permission: {
        // 交易通
        purchase: 810, //采购入库
        sales: 820, //销售出库
        company: 800, //公司设置
        supplier: 801, //供销商
        client: 802, //客户
        cultureBreed: 803, //产品
        productSpec: 804, //规格
        userSetting: 805, // 交易通用户管理
        batch: 806, //批次
        pingcang: 808, //平仓
        vehicle: 807, //车辆
        warsehouse: 830, //仓库设置
        batchReport: 850,
        purchaseReportTotal: 812, //采购汇总表
        salesReportTotal: 822, //销售汇总表
        stockDetail: 1020, // 库存明细报表
        stockTotal: 1021, // 库存汇总表
        receipt: 840, // 收款单
        payment: 841, // 付款单
        receiptDetail: 1000, // 客户欠款明细
        receiptTotal: 1001, // 客户欠款汇总
        paymentDetail: 1010, // 应付款明细
        paymentTotal: 1011, // 应付款汇总
        paymentsTotal: 844, //收款汇总表
        receiptsTotal: 845, //付款汇总表
        edCardTable: 870, //入境登记表
        warsehouseT: 891, //仓库调拨
        inWarehouse: 892, //调拨入库
        outWarehouse: 893, //调拨出库
        gainLoss: 900, //损溢单
        paymentSetting: 833, //收款设置
        costOriginValue: 950, //资产原值
        assetsCalculation: 951, //资产计提
        expenseRecord: 952, //费用记录
        expenseSetting: 953, //费用设置
        equipMent: 834, //设备管理
      },
      word: "",
      memoryValue: "Batch", //存储保存状态
    };
  },
  watch: {
    // 监听isQlwVersion
    whetherQlw(val) {
      this.judgeIsQlw();
    },
  },
  computed: {
    ...mapState(["loginUser", "inQlw", "companyList"]),
    getRoute() {
      return this.$route.path;
    },
    sidebar() {
      return this.leftList;
    },
    // 获取 是否为企联网
    whetherQlw() {
      return this.companyList.isQlwVersion;
    },
  },
  mounted() {
    // console.log("mixin", this.companyList, this.loginUser);
    this.judgeIsQlw();
  },
  methods: {
    getPermissionName(routeName) {
      // console.log(routeName);
      switch (routeName) {
        case "/setting/companyManagement/baseSetting":
          this.activeName = "basesetting";
          break;
        case "/setting/companyManagement/pondSetting":
          this.activeName = "pondSetting";
          break;
        case "/setting/companyManagement/cultureBreed":
          this.activeName = "cycleBreed";
          break;
        case "/setting/companyManagement/companySetting":
          this.activeName = "companySetting";
          break;
        case "/setting/personManagement":
          this.activeName = "userSetting"; // 交易通用户管理
          break;
        case "/setting/purchaseUnit":
          this.activeName = "purchaseUnit";
          break;
        case "/setting/materialSetting":
          this.activeName = "materialSetting";
          break;
        case "/buyingAndSelling/fryPurchase":
          this.activeName = "fishPurchase";
          break;
        case "/buyingAndSelling/fishSales":
          this.activeName = "fishSales";
          break;
        case "/buyingAndSelling/materialPurchase":
          this.activeName = "materialPurchase";
          break;
        case "/expense/ExpenseRecord":
          this.activeName = "expenseRecord";
          break;
        case "/expense/expenseSetting/detail":
          this.activeName = "expenseSetting";
          break;
        case "/expense/ExpenseSetting":
          this.activeName = "expenseSetting";
          break;
        case "/productionControl/productionPlan":
          this.activeName = "productPlan";
          break;
        case "/productionControl/cultureCycle":
          this.activeName = "cultureCycle";
          break;
        case "/productionControl/lossManagement":
          this.activeName = "loss";
          break;
        case "/productionControl/turnPondManagement":
          this.activeName = "turnPond";
          break;
        case "/productionControl/proofingManagement":
          this.activeName = "proofing";
          break;
        case "/productionControl/feedingManagement":
          this.activeName = "feeding";
          break;
        case "/productionControl/preventionManagement":
          this.activeName = "prevention";
          break;
        case "/productionControl/waterQualityParameters/parameterInput":
          this.activeName = "waterParametersInput";
          break;
        // 交易通
        case "/sales/salesList":
          this.activeName = "sales";
          break;
        case "/purchase/purchaseList":
          this.activeName = "purchase";
          break;
        case "/setting/supplierSetting":
          this.activeName = "supplier";
          break;
        case "/setting/clientSetting":
          this.activeName = "client";
          break;
        case "/setting/cultureBreed":
          this.activeName = "cultureBreed";
          break;
        case "/setting/productSpec":
          this.activeName = "productSpec";
          break;
        case "/setting/vehicleSetting":
          this.activeName = "vehicle";
          break;
        case "/setting/batchSetting":
          this.activeName = "batch";
          break;
        case "/setting/companySetting":
          this.activeName = "company";
          break;
        case "/receipt":
          this.activeName = "receipt";
          break;
        case "/payment":
          this.activeName = "payment";
          break;
      }
    },
    // 权限判断
    judgeIsQlw() {
      this.getPermissionName(this.$route.path);
      if (this.companyList.isQlwVersion == false) {
        let permission = this.loginUser.permissions.find((item) => {
          return item.permissionId == this.permission[this.activeName];
        });
        if (permission) {
          this.edit = !permission.isReadOnly;
        }
      } else if (this.companyList.isQlwVersion == true) {
        checkPermission.checkEdit(this.$route).then((data) => {
          this.edit = data;
        });
      }
    },
    // 判断是否有sessionstorage
    judgeSession(keyword) {
      let word = sessionStorage.getItem(keyword);
      if (word) {
        this.word = word;
      } else {
        this.word = "";
      }
    },
    getStorage(str) {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue) {
        this.memoryValue = memoryValue;
      } else {
        this.memoryValue = this.memoryValue;
      }
    },
  },
};
